import templateUrl from './pending-events-review.component.html'
import { ScheduleEventAssignedStatus } from '../../../core/services/data-services';
import "./pending-events-review.component.less";

export const PendingEventsReviewComponent = {
    templateUrl,
    bindings: {
        scheduleEvents: "<",
        respond: "&onRespond",
        viewDetails: "&onViewDetails"
    },
    controller: class PendingEventsReviewComponent {
        responsesEnum = ScheduleEventAssignedStatus;
        active: any;
        viewDetails: ({ $event: any }) => void;
        respond: ({ $event: any }) => void;
        constructor() {
            'ngInject';
        }

        onRespond(scheduleEvent, response) {
            this.respond({
                $event: {
                    scheduleEvent: scheduleEvent,
                    response: response
                }
            });
        }

        onViewDetails(scheduleEvent) {
            this.active = scheduleEvent;
            this.viewDetails({
                $event: {
                    scheduleEvent
                }
            });
        }
    }
};
